@if (question) {
  <label class="question-title">{{ question.question_text }}</label>
  <div>
    <input type="text" class="free_text" [value]="question.user_supplied_answer_text" (input)="setValue($event)" data-testid="text-answer-input"/>
  </div>
  <div style="margin-top: 1rem; margin-left: 1rem">
    <lib-button (click)="onNext.emit()">Next</lib-button>
  </div>
}